/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { BlockSlotsApiArg, OverrideData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    blockSlots: build.mutation<OverrideData, BlockSlotsApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/slots/block`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as blockSlotsApi };
export const { useBlockSlotsMutation } = injectedRtkApi;
